import { Fragment, useState } from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../../Themes/Components/AbstractElements';
import PageLoader from '../../../Themes/Layout/PageLoader';
import Chart from '../Components/Chart';
import FiltrarPeriodo from '../Components/FiltrarPeriodo';
import { DASHBOARD_IMPORTACAO_GRAFICOS } from '../../../Themes/Config/appConfig';

const DashboardImportacao = () => {
  const graficos = JSON.parse(localStorage.getItem(DASHBOARD_IMPORTACAO_GRAFICOS));
  const [filtro, setFiltro] = useState(null);

  return (
    <Fragment>
      <PageLoader loaded={graficos.loading} />
      <Breadcrumbs mainTitle='Dashboard - Importação' title='Importação' parent='Dashboard' />
      <Container fluid={true} className='ecommerce-page'>
        <Row>
          <FiltrarPeriodo onFiltrar={setFiltro} onLimpar={() => setFiltro(null)} plugin='importacao' />
        </Row>
        <Row>
          {graficos &&
            graficos.map((graficoData, index) => (
              <Chart key={`${index}-${JSON.stringify(filtro)}`} data={graficoData} plugin={'importacao'} filtro={filtro} />
            ))}
        </Row>
      </Container>
    </Fragment>
  );
};

export default DashboardImportacao;
